export const JobTypes = [
    {
        value: "1",
        label: "Email"
    },
    {
        value: "2",
        label: "Email, Demographic"
    },
    {
        value: "5",
        label: "Demographic"
    },
];

export const ProjectTypes = [
    {
        value: "1",
        label: "Count"
    },
    {
        value: "2",
        label: "Order"
    },
    {
        value: "5",
        label: "Refresh Order"
    },
]

export const NameParser_ParseHint = [
    {
        value: "1",
        label: "DefinitelyFull Name"
    },
    {
        value: "2",
        label: "VeryLikelyFull Name"
    },
    {
        value: "3",
        label: "ProbablyFull Name"
    },
    {
        value: "4",
        label: "Varying Name"
    },
    {
        value: "5",
        label: "ProbablyInverse Name"
    },
    {
        value: "6",
        label: "VeryLikelyInverse Name"
    },
    {
        value: "7",
        label: "Definitely Inverse Name"
    },
    {
        value: "8",
        label: "MixedFirstName Name"
    },
    {
        value: "9",
        label: "MixedLastName Name"
    },
]
export const StandardExportFormat = [
    {
        value: "1",
        label: "Count"
    },
    {
        value: "2",
        label: "Email Order"
    },
    {
        value: "4",
        label: "Demographic Order"
    },
    {
        value: "5",
        label: "Email Demographic Order"
    },
]
